<template>
  <div class="attendee-package-section" v-if="registerForm && participant">
    <div class="package-item">
      <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.registrationForm") }}</span>
      <span>
        <b>{{ registerForm.formInfo.title }}</b>
      </span>
      <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.registrationDate") }}</span>
      <span>{{ $moment(participant.createDate).format("DD MMMM YYYY, dddd HH:mm:ss") }}</span>
      <template v-if="getPacket() && this.participant.packetID != null">
        <span>
          {{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.registrationPackage") }}
        </span>
        <!-- <span><b>Standart paket</b> [Early Bird]</span> -->
        <span>
          <b>{{ getPacket().title }}</b>
          <template v-if="participant.paymentInfos[0] != null && participant.paymentInfos[0].priceOptionId != null">[{{ participant.paymentInfos[0].packet.priceOptions.find(x => x.id == participant.paymentInfos[0].priceOptionId).title }}]</template>
        </span>
        <span v-if="participant.paymentInfos.length > 0">{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.price") }}</span>

        <span v-if="participant.paymentInfos.length > 0 && participant.paymentInfos[0] != null && participant.paymentInfos[0].priceOptionId != null">
          {{ $currency.format(participant.paymentInfos[0].packet.priceOptions.find(x => x.id == participant.paymentInfos[0].priceOptionId).price, { code: $parseCurrency(registerForm.paymentInfo.currency) }) }}
        </span>
        <span v-else-if="participant.paymentInfos.length > 0">
          <b>{{ $currency.format(participant.paymentInfos[0].packetPrice, { code: $parseCurrency(registerForm.paymentInfo.currency) }) }}</b>
        </span>
      </template>

      <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.daysOfParticipation") }}</span>
      <span v-if="participant.dayRestrictions.length == 0">
        <b>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.noRestrictions") }}</b>
      </span>
      <span v-else>
        <el-tag v-for="(day, dayIndex) in participant.dayRestrictions" :key="dayIndex">
          {{ $moment(day).format("DD MMMM YYYY, dddd") }}
        </el-tag>
      </span>
      <template v-if="registerForm.paymentInfo.createDate">
        <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.registrationInfo.registrationDate") }}</span>
        <span>
          <b>{{ $moment(registerForm.paymentInfo.createDate).format("DD MMMM YYYY, dddd HH:mm") }}</b>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    registerForm: Object,
    participant: Object
  },
  methods: {
    getPacket() {
      return this.registerForm.packets.find(x => x.id == this.participant.packetID);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/RegistrationInfo.vue